import { ref, computed } from 'vue';
import { parseISO, differenceInDays } from 'date-fns';
import { API, graphqlOperation } from 'aws-amplify';
import { listStakings } from '@/graphql/queries';
import { createStaking } from '@/graphql/mutations';

import { useActivity } from '@/composables/activity';

export const dailyRewardRule = {
	common: 20,
	uncommon: 30,
	rare: 50,
	epic: 80,
	legendary: 110,
	founders: 150,
};

export const totalPendingReward = ref(0);

export const useStaking = (wallet_id, bulldroid) => {
	const loading = ref(false);
	const pending = ref(false);
	const error = ref(null);
	const staking = ref(null);
	const pendingReward = ref(0);

	const dailyReward = computed(() => dailyRewardRule[bulldroid.attributes['rarity level']]);

	const listStakingsQuery = async () => {
		loading.value = true;

		try {
			const result = await API.graphql(graphqlOperation(listStakings, {
				limit: 10000,
				filter: {
					and: [
						{
							bulldroid_id: {
								eq: bulldroid.id,
							},
						},
						{
							wallet_id: {
								eq: wallet_id,
							},
						},
					],
				},
			}));

			if (result.data.listStakings.items[0]) {
				const data = result.data.listStakings.items[0];

				// Calc pending reward
				const days = differenceInDays(new Date('2022-06-15'), parseISO(data.createdAt));
				const reward = days * dailyReward.value;
				pendingReward.value = reward;
				// Update total pending reward
				totalPendingReward.value += reward;

				staking.value = data;
			}
		} catch (err) {
			error.value = err;
		} finally {
			loading.value = false;
		}
	};

	const createStakingMutation = async () => {
		const {
			createActivityMutation,
		} = useActivity();

		pending.value = true;

		try {
			const result = await API.graphql(graphqlOperation(createStaking, {
				input: {
					bulldroid_id: bulldroid.id,
					wallet_id,
				},
			}));

			if (result.data.createStaking.id) {
				const data = result.data.createStaking;
				staking.value = data;

				const payload = {
					wallet_id,
					bulldroid_id: bulldroid.id,
					action: 'stake',
				};
				createActivityMutation(payload);
			}
		} catch (err) {
			error.value = err;
		} finally {
			pending.value = false;
		}
	};

	listStakingsQuery();

	return {
		loading,
		pending,
		error,
		dailyReward,
		pendingReward,
		staking,

		createStakingMutation,
	};
};
